import {
	AfterViewInit,
	Component,
	ElementRef,
	Inject,
	Renderer2,
	ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import {
	AppModalService,
	ModalData,
} from '@datachain/ui-sdk/components/app-modal';
import { Store } from '@ngrx/store';
import { Map } from 'immutable';
import { map, Observable } from 'rxjs';

import { DcIcons } from '../../../../ui/app-dc.icons';
import { ColumnModelItemEntity } from '../../../domain/column-model-item.entity';
import { SubscriptionDiagnosticError } from '../../../domain/diagnostic-errors.entity';
import { ProfileItemEntity } from '../../../domain/profile-item.entity';
import { SubscriptionProvider } from '../../../providers/subscription.provider';
import {
	refreshProfilesForSimulation,
	SubscriptionSimulatorSelector,
} from '../../../store';
import { ProfilesComponent } from '../../profiles/profiles.component';
import { ProfileSelectionViewProvider } from './profile-selection-view.provider';

@Component({
	selector: 'app-profile-selection-modal',
	templateUrl: './profile-selection-modal.component.html',
	styleUrls: ['./profile-selection-modal.component.scss'],
	providers: [SubscriptionProvider, ProfileSelectionViewProvider],
})
export class ProfileSelectionModalComponent<
		T extends { selectedProfileId: string }
	>
	extends DcBaseComponent
	implements AfterViewInit
{
	@ViewChild(ProfilesComponent)
	private readonly profilesCmp: ProfilesComponent | null = null;

	public vo$: Observable<{
		profiles: Map<string, ProfileItemEntity>;
		columnModels: Map<string, ColumnModelItemEntity>;
		selectedProfileId: string;
		error: SubscriptionDiagnosticError | undefined;
	}>;

	protected readonly DcIcons = DcIcons;
	public constructor(
		private readonly store: Store,
		private readonly selector: SubscriptionSimulatorSelector,
		private readonly modalService: AppModalService,
		private readonly subscriptionProvider: SubscriptionProvider,
		private readonly profileSelectionViewProvider: ProfileSelectionViewProvider,
		private readonly renderer: Renderer2,
		private readonly elemRef: ElementRef,
		@Inject(MAT_DIALOG_DATA) public readonly modalData: ModalData & T
	) {
		super();
		this.cmpId = 'profile-selection-modal';

		this.vo$ = combineAll({
			profiles: this.selector.getProfilesForSimulation$(),
			columnModels: this.selector.getColumnModelsForSimulation$(),
			selectedProfileId: this.modalData.selectedProfileId,
			error: this.subscriptionProvider.errors$.pipe(
				map((errors) => errors.valueSeq().first())
			),
		});
	}

	public override ngAfterViewInit(): void {
		setTimeout(
			() =>
				this.profileSelectionViewProvider.adjustHeights(
					this.elemRef,
					this.renderer
				),
			750
		);
	}

	public refreshProfiles(): void {
		this.store.dispatch(refreshProfilesForSimulation());
	}

	public launchAction(): void {
		if (!this.profilesCmp) {
			return;
		}

		const selectedProfiles = this.profilesCmp.getSelectedProfiles();

		this.modalService.closeActiveModal({
			profiles: selectedProfiles,
		});
	}
}
